import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { TicketKind, TicketListItem, TicketPriority, TicketStatus } from '@/features/stacktrace/tickets/-query/type';

/**
 * プロダクション詳細 > 開発スコープタブ のテーブル列ID。
 *
 * 表示項目: コード / タイトル / 種別 / ステータス / 優先度 / プロダクト / 期限日 / 担当者
 * 親プロダクション配下のコンテキストで自明なため「対象リリース」列は表示しない。
 */
export const TicketTableColumns = {
  CODE: 'CODE',
  TITLE: 'TITLE',
  KIND: 'KIND',
  STATUS: 'STATUS',
  PRIORITY: 'PRIORITY',
  PRODUCT: 'PRODUCT',
  DUE_DATE: 'DUE_DATE',
  ASSIGNEES: 'ASSIGNEES'
} as const;
export type TicketTableColumns = EnumUnion<typeof TicketTableColumns>;
type TicketCodeColumn = {
  id: string;
  code: string;
};
type TicketProductColumn = {
  id: string;
  name: string;
};
type TicketAssigneeColumn = {
  personId: string;
  name: string;
};
export type TicketTableRowData = {
  [TicketTableColumns.CODE]: TicketCodeColumn;
  [TicketTableColumns.TITLE]: string;
  [TicketTableColumns.KIND]: TicketKind | undefined;
  [TicketTableColumns.STATUS]: TicketStatus | undefined;
  [TicketTableColumns.PRIORITY]: TicketPriority | undefined;
  [TicketTableColumns.PRODUCT]: TicketProductColumn;
  [TicketTableColumns.DUE_DATE]: string | null;
  [TicketTableColumns.ASSIGNEES]: TicketAssigneeColumn[];
};
export const convertTicketItemToTableRow = (item: TicketListItem): TicketTableRowData => {
  return {
    [TicketTableColumns.CODE]: {
      id: item.id,
      code: item.code
    },
    [TicketTableColumns.TITLE]: item.title,
    [TicketTableColumns.KIND]: item.kind as TicketKind | undefined,
    [TicketTableColumns.STATUS]: item.status as TicketStatus | undefined,
    [TicketTableColumns.PRIORITY]: item.priority as TicketPriority | undefined,
    [TicketTableColumns.PRODUCT]: {
      id: item.productId,
      name: item.productName
    },
    [TicketTableColumns.DUE_DATE]: item.dueDate,
    [TicketTableColumns.ASSIGNEES]: item.assignees
  };
};